import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import {from, Observable, of, throwError} from 'rxjs';
import {catchError, map, switchMap, take} from 'rxjs/operators';
import {Auth, getIdToken} from '@angular/fire/auth';
import {inject} from "@angular/core";

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const auth = inject(Auth);

  return from(auth.authStateReady()).pipe(
    take(1),
    switchMap(() => {
      const user = auth.currentUser;

      if (user) {
        return getIdToken(user);
      } else {
        return of(null);
      }
    }),
    switchMap(token => {
      let copiedRequest = req.clone({
        setHeaders: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (token) {
        copiedRequest = req.clone({
          setHeaders: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
      }

      return next(copiedRequest).pipe(
        catchError(error => {
          if (error.error instanceof ErrorEvent) {
            console.error('This is a client side error');
          } else {
            console.error('This is a server side error');
          }

          return throwError(() => error);
        }),
        map((evt: HttpEvent<any>) => {
          return evt;
        }),
      );
    }),
  );
}
